import { call, onSuccess } from 'actionware';
import { authLogin } from '../login/loginActions';
import * as R from 'ramda';

export const STEP_USER_REGISTRATION = 1;
export const STEP_EMAIL_VALIDATION = 2;
export const STEP_PHONE_VALIDATION = 3;

export async function registerUser(userData) {
  // Save the user using the api
  // return apiFetch('auth/register', 'POST', userData);
  return userData;
}

export async function sendEmailVerification({ getState }) {
  // TODO: Send an email to the user to verify it (automatically called on register)
  // const { registration: { userData } } = getState();
  // return apiFetch('auth/send_verification_email', 'PUT', userData);
}

export async function sendPhoneVerification() {
  // TODO: Send a phone code to the user to verify its
  // return apiFetch('auth/send_verification_phone_code', 'PUT', phoneCode);
}

export async function validatePhoneCode(phoneCode) {
  return false;
}

export function registrationMoveToStep(step) {
  return step;
}

// Side effects
// ------------------------------

onSuccess(registerUser, () => {
  call(sendEmailVerification);
});

onSuccess(sendEmailVerification, () => {
  call(registrationMoveToStep, STEP_EMAIL_VALIDATION);
});

onSuccess(sendPhoneVerification, () => {
  call(registrationMoveToStep, STEP_PHONE_VALIDATION);
});

onSuccess(validatePhoneCode, async ({ store: { getState } }) => {
  const { registration: { userData, isValidPhoneCode } } = getState();
  if (isValidPhoneCode) {
    // We wait 3 seconds to allow the user to read the success
    // message and then we login and redirect to home
    setTimeout(() => {
      call(authLogin, R.pick(['email', 'password'], userData));
    }, 3000);
  }
});
